import { render, staticRenderFns } from "./LoginText.vue?vue&type=template&id=3ac0423c&"
import script from "./LoginText.vue?vue&type=script&lang=js&"
export * from "./LoginText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports